import { Button, Stack, Typography } from '@mui/material';
import { FormTextField } from '../../../design-system';
import { recommendBusinessTitle } from '../model/businessTitleRecommendation';

export type BusinessTitleFieldProps = {
  value: string;
  onChange: (value: string) => void;
  jobProfile?: string;
  jobLevel?: string;
  currentTitle?: string;
  disabled?: boolean;
  helperText?: string;
};

export function BusinessTitleField({
  value,
  onChange,
  jobProfile,
  jobLevel,
  currentTitle,
  disabled = false,
  helperText,
}: BusinessTitleFieldProps) {
  const recommendation = recommendBusinessTitle(jobProfile, jobLevel);

  return <Stack role="group" aria-label="직함 설정" spacing={1} sx={{ flex: 1, minWidth: 0, width: '100%' }}>
    <FormTextField
      fullWidth
      label="직함 (선택)"
      value={value}
      disabled={disabled}
      helperText={helperText}
      onChange={(event) => onChange(event.target.value)}
    />
    {currentTitle !== undefined && <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
      현재 직함: {currentTitle || '지정하지 않음'}
    </Typography>}
    {recommendation && <Stack spacing={0.75}>
      <Typography variant="body2" aria-live="polite" sx={{ overflowWrap: 'anywhere' }}>추천 직함: {recommendation}</Typography>
      <Button
        type="button"
        size="small"
        variant="outlined"
        disabled={disabled || value === recommendation}
        onClick={() => onChange(recommendation)}
        sx={{ alignSelf: 'flex-start' }}
      >추천 직함 사용</Button>
    </Stack>}
  </Stack>;
}
